import React from 'react';
import Img from '../../../../../../components/Img/Img';
import { TAG_RELATED_ITEM_TYPE } from '../../../../../../constants/service/app/tagConstants';
import {
  CS_REVIEW_DETAIL_URL_PATH,
  PRODUCT_EDIT_URL_PATH,
} from '../../../../../../constants/service/common/urlConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../../../lib/common';

const TagPreviewDetailPageImg = (props) => {
  const { className, item } = props;

  if (!item || !item.urlList) {
    return null;
  }

  return (
    <Img
      className={className}
      clickAble={false}
      onClick={() =>
        /**
         *  태그의 연관된 타입에 따라서
         *  상품일 경우 상품 상세 페이지,
         *  상품 후기일 경우에는 상품 후기 상세 페이지를
         *  새로운 브라우저창으로 열도록 함.
         */
        openNewWindow(
          setDetailPageUrl(
            item.tagRelatedItemType === TAG_RELATED_ITEM_TYPE.PRODUCT
              ? PRODUCT_EDIT_URL_PATH
              : CS_REVIEW_DETAIL_URL_PATH,
            item.id,
          ),
        )
      }
      src={item.urlList[0]}
    />
  );
};

export default TagPreviewDetailPageImg;
